export default __webpack_public_path__ + "static/media/fujairah-free-zone.0df6b161.png";